import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-google-review-page',
    templateUrl: './google-review-page.component.html',
    styleUrls: ['./google-review-page.component.scss'],
    standalone: false
})
export class GoogleReviewPageComponent implements OnInit {

    googleReviewUrl = 'https://g.page/r/Ca_9-JEswZPVEBM/review';

    constructor(private seoService: SeoService) { }

    ngOnInit(): void {
        // Update SEO for Google Review page
        this.seoService.updateSEO({
            title: 'Google Reviews | Staten Driving School Staten Island',
            description: 'See what our students say about Staten Driving School. 4.9-star rated driving school in Staten Island, NY. Read real student reviews and testimonials.',
            keywords: 'driving school reviews, Staten Island driving school ratings, student testimonials, driving instructor reviews',
            canonical: 'https://statendrivingschool.com/google-review'
        });
    }

    openGoogleReview() {
        window.open(this.googleReviewUrl, '_blank');
    }
} 